import React, { useState } from 'react';
import { doc, setDoc, deleteDoc, getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * TeamSaveControls
 * Saves selected team names for a user under users/{userId}/savedTeams (doc IDs are team names)
 *
 * Props:
 * - userId: string
 * - selectedTeams: string[] | Set<string>
 * - onSaved?: (message: string) => void
 * - className?: string
 * - label?: string (default 'Opslaan')
 */
export default function TeamSaveControls({ userId, selectedTeams, onSaved, className, label = 'Opslaan' }) {
  const [saving, setSaving] = useState(false);

  const save = async () => {
    console.log('TeamSaveControls: save clicked. userId =', userId);
    if (!userId) {
      console.warn('TeamSaveControls: no userId available; aborting save');
      return;
    }
    setSaving(true);
    try {
      const selectedArr = Array.from(selectedTeams instanceof Set ? selectedTeams : (selectedTeams || []));
      const snap = await getDocs(collection(db, 'users', userId, 'savedTeams'));
      const existing = snap.docs.map(d => d.id);

      const toAdd = selectedArr.filter(t => !existing.includes(t));
      const toDelete = existing.filter(t => !selectedArr.includes(t));

      const addPromises = toAdd.map(team => setDoc(doc(db, 'users', userId, 'savedTeams', team), { selected: true }));
      const delPromises = toDelete.map(team => deleteDoc(doc(db, 'users', userId, 'savedTeams', team)));

      await Promise.all([...addPromises, ...delPromises]);
      onSaved?.('Teams succesvol opgeslagen!');
    } catch (err) {
      console.error('Error bij het opslaan van Teams', err);
      onSaved?.('Error bij het opslaan van Teams');
    } finally {
      setSaving(false);
    }
  };

  return (
    <button type="button" className={className} disabled={!userId || saving} onClick={save}>
      {saving ? 'Opslaan...' : label}
    </button>
  );
}
